/**
 * O CONFIRM DE EXCLUIR ASSINATURA DIZ O QUE ACONTECE (10/10/2026).
 *
 * Dizia só "Deseja excluir #123?", sem o cliente, e a falha dizia "Erro". No banco:
 *  - invoices.contractId é NO ACTION: assinatura com fatura NÃO sai (o banco recusa);
 *  - contract_adjustments e adjustment_events são CASCADE: as anualidades saem JUNTO, caladas.
 * Agora o confirm nomeia o cliente e diz as duas coisas, lidas na hora. O que não deu para ler é "não consegui
 * conferir", nunca "nenhuma". (Recusar a exclusão com anualidades no servidor é pendência do backend.)
 */
export interface ConfirmacaoDeExcluirAssinatura {
  titulo: string;
  mensagem: string;
  /** A exclusão vai falhar com certeza (há faturas): o confirm avisa, e o botão segue para o operador ver o motivo. */
  vaiFalhar: boolean;
}

export function confirmacaoDeExcluirAssinatura(p: {
  id: number;
  cliente: string | null;
  /** null = não deu para ler. */
  faturas: number | null;
  anualidades: number | null;
}): ConfirmacaoDeExcluirAssinatura {
  // O cliente vai no corpo, não no título: a casca do confirm trunca o título numa linha, e "#112 de C…" escondia
  // justamente o nome (visto na prévia de 10/10/2026).
  const linhas: string[] = [p.cliente ? `Cliente: ${p.cliente}.` : 'Não achei o cliente desta assinatura na lista.'];
  if (p.faturas == null) linhas.push('Não consegui conferir as faturas desta assinatura. Se houver alguma, o servidor recusa a exclusão.');
  else if (p.faturas > 0) linhas.push(`Ela tem ${p.faturas} ${p.faturas === 1 ? 'fatura' : 'faturas'}: o servidor recusa a exclusão. Para encerrar a cobrança, mude o status para Cancelado.`);
  if (p.anualidades == null) linhas.push('Não consegui conferir as anualidades de reajuste. Se houver alguma, ela sai junto.');
  else if (p.anualidades > 0) linhas.push(`${p.anualidades} ${p.anualidades === 1 ? 'anualidade de reajuste sai' : 'anualidades de reajuste saem'} junto, sem volta.`);
  if (p.faturas === 0 && p.anualidades === 0) linhas.push('Ela não tem faturas nem anualidades de reajuste.');
  linhas.push('Esta ação não pode ser desfeita.');
  return {
    titulo: `Excluir a assinatura #${p.id}?`,
    mensagem: linhas.join('\n\n'),
    vaiFalhar: (p.faturas ?? 0) > 0,
  };
}
